import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { HelpIndex } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';

// modal component that should be used in other modals' html file. do not inherit from this in the modal ts file as it will lead to multiple instances of the component
@Component({
    standalone: false,
    selector: 'res-base-modal',
    templateUrl: './modal.component.html'
})
export class ModalComponent {
    @Input() modalClass: string;
    @Input() modalAutomationId: string;
    // if not set modalAutomationId is used also for the container, added this for modals that need to have different container auto ids on sequential openings
    @Input() modalContainerAutomationId: string;
    @Input() titleText = '';
    // if this is not set the modal will not have help button (e.g. delete entity modal)
    @Input() modalHelpIndex: HelpIndex;
    @Input() verifyRequiredValidator: boolean;
    @Input() primaryButtonLabel: string;
    @Input() primaryButtonCustomClass: string;
    @Input() secondaryButtonLabel: string;
    @Input() modalTitle: string;
    @Input() modalTitleSecondPart: string = null;
    @Input() isPrimaryBtnEnabled: () => boolean;
    @Input() isPrimaryButtonHidden = false;
    @Input() isCloseButtonVisible = true;
    @Input() isCloseButtonDisabled = false;
    @Input() isBusy = false;
    @Input() isBusyMessage: string;
    @Output() primaryButtonActionEmt = new EventEmitter();
    @Output() closeButtonActionEmt = new EventEmitter();
    @Input() buttonTemplate: TemplateRef<any>;
    @Input() middleButtonTemplate: TemplateRef<any>;
    @Input() showButtonBar = true;

    @Input() resizeHorizontal: boolean;
    @Input() resizeHorizontalMin: number;
    @Input() resizeHorizontalMax: number;
    @Input() resizeVertical: boolean;
    @Input() resizeVerticalMin: number;
    @Input() resizeVerticalMax: number;
    @Input() maximizable: boolean;
    @Input() modalDraggable = true;
    @Input() modalHasVariableHeight: boolean | number;
    @Input() modalHasVariablePosition: boolean;
    @Input() maximizableAutoId: string;

    @Input() isAddTextToSyntheticDocumentModal: boolean;

    constructor(
        private modalComponentCommonService: CommonService, private cdr: ChangeDetectorRef) { }

    primaryButtonAction(): void {
        this.primaryButtonActionEmt.emit();
    }

    closeButtonAction(): void {
        this.closeButtonActionEmt.emit();
    }

    openHelp = () => this.modalHelpIndex ? this.modalComponentCommonService.openHelp(this.modalHelpIndex) : null;

    ngAfterViewInit() {
        setTimeout(() => this.cdr.detectChanges());
    }
}
